'use client';

import { Scrollable } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { CategoryConstantType } from '@/@types';
import { Element, Image } from '@/components/core/components/atoms';
import { useLingui } from '@lingui/react';
import { categories } from '@/@constants';
import { useCallback, useRef } from 'react';
import SearchBar from '@/components/core/components/organism/search-bar';
import { useLocalizedLinks, useOnViewport } from '@/components/core/hooks';
import { useLayout } from '@/components/context/layout';
import InternalLink from '@/components/core/components/organism/internal-link';
import * as styles from './hero.styles';

const CategoryTab: UIComponent<{ category: CategoryConstantType }> = ({ category, children }) => {
  const { i18n } = useLingui();
  const links = useLocalizedLinks();
  return (
    <InternalLink href={links.categoryLanding(category)} className={clsx(styles.categoryTab)}>
      <Image alt={category.name as string} src={`/trimed/${category.name}.png`} />
      <span>{children || i18n._(category.title)}</span>
    </InternalLink>
  );
};

const options = {
  rootMargin: '-100px 0px 0px 0px',
};

const Hero: UIComponent = ({ className }) => {
  const ref = useRef(null);
  const [, setLayoutState] = useLayout();
  const onSearchHidden = useCallback(
    (onViewport) => {
      return setLayoutState((state) => {
        return { ...state, searchNavbarVisible: !onViewport };
      });
    },
    [setLayoutState],
  );
  useOnViewport(ref, onSearchHidden, { options });
  return (
    <section className={clsx(className, styles.root)}>
      <h1>
        <Trans>Find trustworthy recommendations</Trans>
      </h1>
      <Scrollable snap className={styles.searchCategorySelector}>
        <div className={styles.scrollContent}>
          <Element className={clsx(styles.omnisearch, styles.categoryTab)} lines={1}>
            <Trans>Search all</Trans>
          </Element>
          <CategoryTab category={categories.restaurants} />
          <CategoryTab category={categories.movies}>
            <Trans>Movies and Series</Trans>
          </CategoryTab>
        </div>
      </Scrollable>
      <div className={styles.search} ref={ref}>
        <SearchBar className={styles.search} />
      </div>
    </section>
  );
};

export default Hero;
